import Vue from 'vue'

Vue.prototype.$observer = function(data, keys) {
    keys.forEach(key => {
      Object.defineProperty(data, key, {
        enumerable: true,
        get: () => this[key]
      });
    });
  };


// WEBPACK FOOTER //
// ./src/plugins/utils.js